import { Injectable } from '@angular/core';

import { environment } from '@env/environment';
import VERSION from '@env/version';

@Injectable()
export class PropertiesService {

  PRODUCTION: boolean;
  PLAYGROUND: boolean;
  DEMO: boolean;
  API_BASE_URL: string;
  VERSION: Version.VersionModel;

  LINKEDIN_AUTH_URL: string;
  GITHUB_AUTH_URL: string;
  GOOGLE_AUTH_URL: string;

  demoCredentials : Session.LoginFormModel;
  SSO_URL: string;

  getProperties(): void {
    const env: any = environment;

    this.PRODUCTION = env.production;
    this.API_BASE_URL = env.apiBaseUrl;
    this.PLAYGROUND = env.playground;
    this.DEMO = env.demo;

    this.LINKEDIN_AUTH_URL = env.auth?.linkedin?.authBaseUrl
      + '?response_type=code&client_id=' + env.auth?.linkedin?.clientId
      + '&redirect_uri=' + env.auth?.linkedin?.redirectUrl
      + '&scope=' + env.auth?.linkedin?.scope;

    this.GITHUB_AUTH_URL = env.auth?.github?.authBaseUrl
      + '?scope=' + env.auth?.github?.scope
      + '&client_id=' + env.auth?.github?.clientId;

    this.GOOGLE_AUTH_URL = env.auth?.google?.clientId + env.auth?.google?.authBaseUrl;

    this.demoCredentials = env.auth?.credentials;

    this.VERSION = VERSION;
    this.SSO_URL="/SSO/metadata"
  }
}
